/** The Features Guide in Arabic. Mirrors `../en/guide.js` key for key. */
export const GUIDE = {
  eyebrow: 'دليل الاستخدام',
  title: 'كل ميزة، وكيف تستخدمها',
  text: 'شرح خطوة بخطوة لكل لوحة. اقرأه من البداية إلى النهاية، أو ابحث عما تحتاجه.',
  search: {
    label: 'ابحث في الدليل',
    placeholder: 'ابحث عن ميزة، مثل الدعوة أو القاعات أو الزوار',
  },
  contentsLabel: 'المحتويات',
  chapterLabel: 'الفصل',
  whoLabel: 'من يستخدمه:',
  stepsLabel: 'الخطوات',
  tipLabel: 'معلومة مفيدة.',
  results: (count, query) => `نتائج البحث عن «${query}»: ${count}`,
  clear: 'مسح البحث',
  none: 'لا يوجد في الدليل ما يطابق بحثك.',
  help: {
    title: 'هل ما زلت بحاجة إلى مساعدة؟',
    text: 'يمكن للمسؤولين إرسال طلب من الدعم في لوحة المسؤول، أو مراسلتنا.',
    cta: { label: 'تواصل معنا', href: '/contact' },
  },
  chapters: [
    {
      id: 'getting-started',
      title: 'البداية',
      intro: 'كل ما تحتاجه في دقائقك الأولى مع MeetNPlan.',
      who: 'الجميع',
      features: [
        {
          id: 'sign-in',
          title: 'تسجيل الدخول',
          text: 'يسجّل الجميع الدخول من app.meetnplan.co. ينتقل الأعضاء إلى تطبيق الحجز، ويفتح المشرف والموارد البشرية والاستقبال كلٌّ لوحته الخاصة.',
          steps: [
            'انتقل إلى app.meetnplan.co، وأدخل بريدك الإلكتروني ثم اضغط التالي. ويمكنك أيضًا الضغط على المتابعة باستخدام جوجل.',
            'لفتح لوحة، اضغط زر عضو بجوار بريدك واختر مشرف أو الموارد البشرية أو الاستقبال.',
            'أدخل كلمة المرور، ولا تترك إبقائي مسجّلًا الدخول محددًا إلا على جهازك الشخصي.',
            'اضغط أدخل لوحة القيادة، أو افتح لوحة المشرف أو افتح لوحة الموارد البشرية أو افتح لوحة الاستقبال.',
            'إذا أخبرك MeetNPlan أن حسابك يسجّل الدخول من صفحة أخرى، فاضغط رابط بدّل إلى الذي يظهر لك.',
          ],
          tip: 'لكل صفحة دخول عنوان خاص يمكنك حفظه في المفضلة: app.meetnplan.co/admin/login و app.meetnplan.co/hr/login و app.meetnplan.co/reception/login.',
        },
        {
          id: 'create-organization',
          title: 'إنشاء مؤسستك',
          text: 'جهّز مساحة عمل جديدة لشركتك في خطوات قليلة. تصبح أنت مشرفها، ويمكنك دعوة فريقك فورًا.',
          steps: [
            'افتح app.meetnplan.co/get-started، أو اضغط أنشئ مؤسسة في صفحة تسجيل الدخول.',
            'أدخل الاسم الأول والاسم الأخير والبريد الإلكتروني للعمل وكلمة المرور، ثم اضغط متابعة. أو اضغط المتابعة باستخدام جوجل لتتخطى كلمة المرور.',
            'اكتب اسم المؤسسة، وأبقِ مربع اسمح لزملائك على @نطاقك بطلب الانضمام محددًا إذا أردت أن ينضم زملاؤك ببريد العمل. وضع علامة على أقبل شروط الخدمة نيابة عن شركتي، وعلى اطلعت على سياسة الخصوصية. ثم اضغط متابعة، أو إنشاء مؤسسة إذا استخدمت جوجل.',
            'أدخل الرمز المكوّن من 6 أرقام الذي وصلك بالبريد، ثم اضغط التحقق وإنشاء التنظيم.',
            'شارك رمز الشركة أو رابط الدعوة، أو أضف عناوين في البريد الإلكتروني، ثم اضغط متابعة. واضغط تخطي الآن لدعوة الأعضاء لاحقًا من لوحة الإدارة.',
          ],
          tip: 'يمكنك استخدام بريد شخصي مثل Gmail أيضًا، وعندها ينضم فريقك برمز الشركة أو برابط دعوة.',
        },
        {
          id: 'join-your-team',
          title: 'انضم إلى فريقك',
          text: 'اطلب الانضمام إلى مساحة عمل شركتك ببريد العمل أو برمز الشركة الذي يعطيك إياه المسؤول. يوافق المشرف أو الموارد البشرية على كل طلب، ويراسلك MeetNPlan فور قبولك.',
          steps: [
            'في صفحة تسجيل الدخول، اضغط سجل بجوار جديد على MeetNPlan؟',
            'اختر بريد العمل أو رمز الشركة، واملأ الحقل، ثم اضغط متابعة عندما تظهر مساحة عملك.',
            'أدخل الاسم الأول والاسم الأخير وكلمة المرور (والبريد الإلكتروني إذا استخدمت رمزًا)، وضع علامة على اطلعت على سياسة الخصوصية، ثم اضغط طلب الانضمام.',
            'أدخل الرمز المكوّن من 6 أرقام من بريدك، ثم اضغط التحقق من وإنشاء حساب.',
            'اضغط عرض حالة الطلب لمتابعة طلبك، واضغط التحقق من الحالة لتحديثها.',
          ],
          tip: 'تحتاج كلمة المرور إلى 8 أحرف فأكثر، مع حرف كبير وحرف صغير ورقم ورمز. ويرفض MeetNPlan أيضًا أي كلمة مرور ظهرت في تسريب بيانات معروف.',
        },
        {
          id: 'accept-invitation',
          title: 'قبول دعوة',
          text: 'يمكن للمشرف أن يرسل إليك دعوة بالبريد أو يشارك معك رابط دعوة، وكلاهما يفتح نموذجًا قصيرًا للانضمام إلى تلك الشركة.',
          steps: [
            'في بريد الدعوة، اضغط زر الانضمام إلى مع اسم شركتك، أو افتح رابط الدعوة الذي وصلك.',
            'أدخل الاسم الأول والاسم الأخير والبريد الإلكتروني وكلمة المرور، وضع علامة على اطلعت على سياسة الخصوصية، ثم اضغط متابعة.',
            'أدخل الرمز المكوّن من 6 أرقام من بريدك، ثم اضغط التحقق وطلب الوصول.',
            'أبقِ صفحة في انتظار الموافقة مفتوحة. عند قبولك تظهر عبارة تم قبولك وتُفتح مساحة عملك.',
          ],
          tip: 'تعمل الدعوة المرسلة بالبريد مع العنوان الذي أُرسلت إليه فقط. وإذا انتهت صلاحية الرابط، فاطلب رابطًا جديدًا.',
        },
        {
          id: 'sign-up-with-google',
          title: 'التسجيل باستخدام جوجل',
          text: 'هل أنت جديد على MeetNPlan ولديك حساب جوجل؟ بعد اختياره تسألك شاشة أخيرة عن مساحة العمل التي تريد الانضمام إليها.',
          steps: [
            'اضغط المتابعة باستخدام جوجل في صفحة تسجيل الدخول، أو التسجيل باستخدام جوجل في صفحة التسجيل، ثم اختر حسابك في جوجل.',
            'في شاشة إكمال ملفك الشخصي، تحقّق من مساحة العمل المطابقة لبريدك، أو أدخل رمز الشركة الذي أعطاك إياه المسؤول.',
            'ضع علامة على اطلعت على سياسة الخصوصية.',
            'اضغط طلب الانضمام، أو طلب الوصول إذا أدخلت رمزًا.',
          ],
          tip: 'اضغط لست أنت؟ لتسجيل الخروج واختيار حساب جوجل آخر.',
        },
        {
          id: 'reset-password',
          title: 'إعادة تعيين كلمة مرور منسية',
          text: 'عيّن كلمة مرور جديدة برمز من 6 أرقام يصل إلى بريدك. يؤدي تغييرها إلى تسجيل خروجك من أجهزتك الأخرى.',
          steps: [
            'في صفحة تسجيل الدخول، أدخل بريدك واضغط التالي، ثم اضغط نسيت كلمة المرور؟',
            'تأكّد من العنوان في حقل البريد الإلكتروني، ثم اضغط إرسال الرمز.',
            'أدخل الرمز المكوّن من 6 أرقام، ثم اضغط التحقق من الكود.',
            'اكتب كلمة المرور في كلمة مرور جديدة ثم أعدها في تأكيد كلمة المرور، واضغط تحديث كلمة المرور.',
            'اضغط تسجيل الدخول وادخل بكلمة المرور الجديدة.',
          ],
          tip: 'يعمل الرمز لمدة 10 دقائق، ويمكنك طلب رمز جديد كل دقيقة، بحد أقصى خمسة رموز في الساعة.',
        },
        {
          id: 'find-your-way-around',
          title: 'التنقل في MeetNPlan',
          text: 'يشترك تطبيق الحجز وكل اللوحات في الشريط الجانبي نفسه، فتبدو كلها مألوفة لك.',
          steps: [
            'استخدم الشريط الجانبي على اليمين لفتح الصفحات. اضغط صفًا مثل اجتماعاتي لعرض طرق العرض فيه، مثل مباشر الآن أو القادمة.',
            'على الجهاز اللوحي أو في نافذة ضيقة، يتحول الشريط الجانبي إلى عمود رفيع من الأيقونات. اضغط صورتك في الأسفل لفتح القائمة كاملة.',
            'اضغط لوحة المسؤول أو لوحة الموارد البشرية أو لوحة الاستقبال في تطبيق الحجز للوصول إلى لوحتك، واضغط فتح تطبيق الحجز للعودة. لا يظهر فتح تطبيق الحجز للاستقبال إلا إذا سمحت الشركة بذلك.',
            'اضغط اسمك أسفل الشريط الجانبي في تطبيق الحجز لفتح الملف الشخصي.',
            'اضغط Ctrl K (أو ⌘K على Mac) في تطبيق الحجز للبحث في الاجتماعات والقاعات والأشخاص.',
          ],
          tip: 'صُمّم MeetNPlan للأجهزة اللوحية والحواسيب المحمولة، لذلك يعرض الهاتف رسالة تنبيه بدل التطبيق.',
        },
        {
          id: 'notification-cards',
          title: 'الإشعارات',
          text: 'تظهر الإشعارات الجديدة كبطاقات تنزلق في زاوية أعلى الصفحة، ثم تختفي بعد 7 ثوانٍ.',
          steps: [
            'رُدّ على الطلب من بطاقته مباشرة، أو اضغط × لتجاهلها.',
            'انقر نقرًا مزدوجًا (أو المس مرتين) على جزء فارغ من رأس أي صفحة لفتح كل إشعاراتك.',
            'اضغط عرض أقل لطيّ القائمة، أو إخفاء لإبعادها. واضغط مسح الكل مرتين لمسح كل شيء.',
            'في تطبيق الحجز، افتح الإشعارات من الشريط الجانبي لرؤية القائمة كاملة، مع طرق العرض الكل وغير مقروء وقراءة ويتطلب اتخاذ إجراء.',
          ],
          tip: 'في تطبيق الحجز، تعرض الزاوية نفسها بطاقة بالخطوات المتبقية لإعداد حسابك، مثل إضافة رقم جوالك أو اختيار إشعارات البريد الإلكتروني.',
        },
        {
          id: 'language-and-sign-out',
          title: 'تبديل اللغة وتسجيل الخروج',
          text: 'يعمل MeetNPlan بالعربية والإنجليزية، وتتحول الواجهة كاملة إلى الاتجاه من اليمين إلى اليسار عند اختيار العربية.',
          steps: [
            'اضغط زر EN أسفل الشريط الجانبي، أو أعلى صفحة تسجيل الدخول، للتبديل إلى الإنجليزية. وفي الواجهة الإنجليزية يظهر الزر نفسه بحرف ع.',
            'لحفظ لغتك في حسابك، افتح الملف الشخصي، واختر اللغة في بطاقة اللغة والتواريخ، ثم اضغط حفظ الإعدادات.',
            'اضغط زر تسجيل الخروج بجوار زر اللغة أسفل الشريط الجانبي.',
          ],
          tip: 'تتيح لك بطاقة اللغة والتواريخ أيضًا اختيار الميلادي أو الهجري من نظام التاريخ.',
        },
      ],
    },
    {
      id: 'user-panel',
      title: 'لوحة المستخدم',
      intro:
        'لوحة المستخدم هي المكان الذي يحجز فيه الأشخاص القاعات ويديرون اجتماعاتهم ويبقون على تواصل. ولكل عضو في شركتك هذه اللوحة.',
      who: 'كل من في شركتك',
      features: [
        {
          id: 'dashboard',
          title: 'لوحة التحكم',
          text: 'تعرض لوحة التحكم يومك في لمحة: ما يجري الآن، وما يليه، والدعوات التي تنتظر ردك، ومدى انشغال الأسبوع.',
          steps: [
            'افتح لوحة التحكم لترى الحدث القادم، أو يُعقد الآن أثناء انعقاد اجتماع.',
            'اضغط انضم الآن أو انضم مبكرًا لاجتماع عبر الإنترنت، أو عرض الاجتماع لرؤية تفاصيله.',
            'اضغط بطاقة مثل بانتظار ردي أو بانتظار قراري للانتقال مباشرة إلى تلك القائمة.',
            'بجانب اليوم، اختر في المكتب أو عن بُعد أو خارج العمل ليعرف الاستقبال مكانك اليوم.',
          ],
          tip: 'اضغط Ctrl+K (أو ⌘K على Mac) في أي صفحة للبحث في الاجتماعات والقاعات والأشخاص.',
        },
        {
          id: 'schedule-meeting',
          title: 'جدولة اجتماع',
          text: 'نموذج واحد قصير يحجز القاعة ويحدد الوقت ويرسل الدعوات، ولا يسألك إلا عمّا يحتاجه نوع اجتماعك.',
          steps: [
            'اضغط جدولة اجتماع في الشريط الجانبي.',
            'اختر طريقة الاجتماع: قاعة أو عبر الإنترنت أو زيارة (لقاء في مكان خارجي)، ثم اضغط التالي.',
            'أدخل اسم الاجتماع واختر نوع الاجتماع: داخلي أو العميل أو شخصي.',
            'حدّد التاريخ ووقت البدء والمدة، ثم اختر القاعة أو الرابط أو المكان.',
            'أضف الحضور في خطوة الضيوف، وراجع خطوة المراجعة، ثم اضغط تأكيد وجدولة.',
          ],
          tip: 'إذا كانت شركتك تشترط موافقة الموارد البشرية على حجز القاعات، يظهر الزر باسم إرسال الطلب، وتُرسل الدعوات بعد الموافقة.',
        },
        {
          id: 'online-meetings',
          title: 'الاجتماعات عبر الإنترنت والمختلطة',
          text: 'اختر عبر الإنترنت للاجتماع بالفيديو. يمكن لـ MeetNPlan إنشاء رابط Google Meet لك، أو يمكنك لصق رابطك الخاص.',
          steps: [
            'اضغط جدولة اجتماع واختر عبر الإنترنت.',
            'في خطوة الرابط، يُنشئ MeetNPlan رابط Google Meet عند التأكيد، وإن لم يتوفر فألصق رابط Zoom أو Teams أو Meet.',
            'للاجتماع المختلط، فعّل احجز أيضًا قاعة للحاضرين في المكتب ثم اختر قاعة.',
            'عند بدء الاجتماع، اضغط انضم الآن في لوحة التحكم أو انضمام في يومي.',
          ],
          tip: 'لا يُنشأ رابط Meet إلا إذا كان تقويم Google مربوطًا في ملفك الشخصي وكانت باقتك تشمل روابط Meet.',
        },
        {
          id: 'client-guests',
          title: 'دعوة العملاء والضيوف من خارج الشركة',
          text: 'ادعُ أشخاصًا من خارج شركتك عبر البريد الإلكتروني، وسيكون الاستقبال بانتظارهم إذا كان الاجتماع في قاعة. تعتمد هذه الميزة على باقتك، ويمكن للموارد البشرية إيقاف دعوة الضيوف من الخارج.',
          steps: [
            'لاجتماع مع عميل، اختر العميل في نوع الاجتماع، ثم أدخل الاسم الكامل والبريد الإلكتروني والجوال لكل عميل في خطوة العميل.',
            'لإضافة أي شخص آخر من الخارج، افتح تبويب ضيف في خطوة الضيوف، وأدخل بياناته ثم اضغط إضافة. وإذا كان الاجتماع في قاعة فأضف شركته ورقم جواله أيضًا.',
            'فعّل مميّز للعميل القادم إلى قاعة ليتجاوز نموذج الزائر في الاستقبال.',
            'تصل الضيوف رسالة بالوقت والمكان، ويردّون باختيار نعم، سأحضر أو اعتذار أو طلب وقت آخر.',
            'عندما يسجّل الاستقبال دخول ضيفك، يصلك إشعار وصول زائر.',
          ],
          tip: 'يتلقى الضيوف أيضًا رسالة تذكير قبل الاجتماع، ويحدد المسؤول موعد إرسالها.',
        },
        {
          id: 'recurring-meetings',
          title: 'تكرار اجتماع',
          text: 'احجز الاجتماع نفسه في عدة تواريخ دفعة واحدة. تعتمد الاجتماعات المتكررة على باقتك.',
          steps: [
            'في خطوة الوقت، فعّل تكرار هذا الاجتماع.',
            'في التكرار، اختر يوميًا أو أسبوعيًا أو شهريًا أو تواريخ محددة. مع أسبوعيًا اختر الأيام في أيام التكرار، ومع تواريخ محددة اضغط التواريخ التي تريدها.',
            'في ينتهي، اختر أبدًا أو بعد عدد من المرات أو في تاريخ.',
            'في خطوة التواريخ، راجع كل تاريخ وغيّر وقت المتعارض منها أو احذفه، ثم اضغط تأكيد وجدولة.',
          ],
          tip: 'لا تُحجز التواريخ إلا ضمن المدة المسموح بها في شركتك، وتُتخطّى أيام العطلة.',
        },
        {
          id: 'conflicts',
          title: 'الأوقات المشغولة والأوقات المقترحة',
          text: 'قبل الحجز، يتحقق MeetNPlan من القاعة ومن تقويمك وتقاويم زملائك، ويخبرك بمن هو مشغول وبعدد دقائق التداخل.',
          steps: [
            'في خطوة القاعة، لا تظهر إلا القاعات المتاحة في ذلك الوقت، ما لم يكن الاجتماع مع عميل.',
            'إذا كان لديك اجتماع في الوقت نفسه، تعرض خطوة المراجعة رسالة لديك حجز آخر في هذا الوقت مع مدة التداخل بالدقائق.',
            'في اختر وقتًا جديدًا، اضغط أحد الأوقات المقترحة، أو اضغط اختر وقتًا آخر.',
            'إذا كان بعض المدعوين مشغولين، يذكر MeetNPlan أسماءهم. ويمكنك الحجز رغم ذلك، وبإمكانهم الاعتذار.',
          ],
          tip: 'تُحتسب أيضًا الأوقات المشغولة في تقويم Google المربوط لدى زملائك. أما الضيوف من خارج شركتك فلا يمكن التحقق من أوقاتهم، ويُعلمك MeetNPlan بذلك.',
        },
        {
          id: 'answer-invites',
          title: 'الرد على الدعوات',
          text: 'تجد كل الاجتماعات التي دُعيت إليها في قائمة واحدة، وتردّ عليها بضغطة واحدة، ويُبلَّغ المنظّم بردّك.',
          steps: [
            'افتح دعوات الاجتماعات واختر الكل، أو قيد الانتظار للدعوات التي لم تردّ عليها بعد.',
            'اضغط قبول أو ربما أو رفض على الدعوة.',
            'عند الرفض، أضف سببًا إن شئت ثم اضغط رفض مرة أخرى للتأكيد.',
            'لرفض عدة دعوات معًا، اضغط تحديد واختر الدعوات ثم اضغط رفض المحدد.',
          ],
          tip: 'يمكنك أيضًا الضغط على قبول أو اعتذار مباشرة من رسالة الدعوة، وتغيير ردّك لاحقًا من التطبيق.',
        },
        {
          id: 'meeting-details',
          title: 'فتح اجتماع',
          text: 'يُفتح كل اجتماع في نافذة واحدة تعرض وقته ومكانه ورابطه والحضور. وتفتح روابط الاجتماعات في رسائل MeetNPlan النافذة نفسها.',
          steps: [
            'اضغط اجتماعًا في التقويم، أو اضغط عرض الاجتماع في لوحة التحكم، أو افتح رابط اجتماع من رسالة بريد.',
            'اطّلع على القاعة أو الرابط أو العنوان، والحضور وعدد من قبلوا منهم.',
            'اضغط رابط الاجتماع للانضمام، أو اضغط فتح المحادثة لمراسلة الحضور.',
            'إذا كنت منظّم الاجتماع، اضغط حذف لإلغائه لدى الجميع.',
          ],
          tip: 'إذا أُلغي الاجتماع بعد إرسال الرسالة، يعرض الرابط عبارة هذا الاجتماع غير متاح.',
        },
        {
          id: 'my-day',
          title: 'يومي',
          text: 'يعرض يومي اجتماعاتك ليوم واحد، السابقة والجارية والقادمة، سواء كانت في قاعة أو عبر الإنترنت أو زيارة.',
          steps: [
            'افتح يومي. استخدم الأسهم للانتقال إلى يوم آخر، واضغط اليوم الظاهر في المنتصف للعودة إلى اليوم.',
            'في الاجتماع الجاري، اضغط انضمام لفتح رابط الفيديو.',
            'بصفتك المنظّم، اضغط + 15m لإبقاء القاعة 15 دقيقة إضافية، أو إنهاء لإنهاء الاجتماع الآن وإخلاء القاعة.',
            'إذا كانت شركتك تُخلي القاعات غير المؤكدة، اضغط نحن هنا لتأكيد أن القاعة قيد الاستخدام.',
          ],
          tip: 'يمكنك تمديد الاجتماع حتى ساعة واحدة كحد أقصى، وبعدها أعد جدولته بدلًا من ذلك.',
        },
        {
          id: 'calendar',
          title: 'التقويم',
          text: 'اطّلع على اجتماعات شركتك حسب اليوم أو الأسبوع أو الشهر، أو جنبًا إلى جنب حسب القاعة، واحجز وقتًا متاحًا مباشرة من الجدول.',
          steps: [
            'افتح التقويم واختر اليوم أو الأسبوع أو الشهر أو القاعات.',
            'استخدم الأسهم للتنقل، واضغط عنوان الفترة للعودة إلى اليوم، واضغط تصفية القاعات لعرض القاعات التي تحتاجها فقط.',
            'من التقويم في الشريط الجانبي، اختر اجتماعاتي أو السابقة أو مباشر الآن أو القادمة لتضييق العرض.',
            'في عرض اليوم أو الأسبوع أو القاعات، اسحب على وقت فارغ لحجزه، فتُفتح نافذة الجدولة والوقت محدد مسبقًا، والقاعة أيضًا في عرض القاعات.',
          ],
        },
        {
          id: 'drag-calendar',
          title: 'السحب للنقل أو التمديد',
          text: 'انقل اجتماعك بسحبه إلى وقت جديد، أو غيّر مدته بسحب حافته السفلية، ويُبلَّغ جميع المدعوين بالتغيير.',
          steps: [
            'افتح التقويم في عرض اليوم أو الأسبوع.',
            'اسحب أحد اجتماعاتك إلى وقت أو يوم جديد.',
            'اسحب حافته السفلية إلى الأسفل لإطالته، أو إلى الأعلى لتقصيره.',
            'تؤكد رسالة قصيرة التغيير، مثل نُقل إلى أو ضُبطت المدة على.',
          ],
          tip: 'إذا كانت القاعة أو كنت أنت مشغولًا في الوقت الجديد، يبقى الاجتماع في مكانه. أما الاجتماع الجاري فيمكن تمديده فقط.',
        },
        {
          id: 'manage-meetings',
          title: 'إعادة جدولة اجتماع أو إلغاؤه',
          text: 'تعرض اجتماعاتي الاجتماعات التي تنظّمها، فيمكنك نقلها أو إلغاؤها أو حذف القديمة منها، ويُبلَّغ المدعوون بكل تغيير.',
          steps: [
            'افتح اجتماعاتي واختر الكل، أو عرضًا مثل القادمة أو ملغاة أو القاعة أو عبر الإنترنت أو زيارة.',
            'مرّر المؤشر على الاجتماع واضغط إعادة جدولة الاجتماع، ثم اختر التاريخ أو الوقت أو المدة أو القاعة الجديدة واضغط إعادة جدولة.',
            'للإلغاء، اضغط حذف الاجتماع ثم أكّد.',
            'عند حذف اجتماع متكرر، اختر هذا الاجتماع فقط أو هذا الاجتماع وما بعده أو السلسلة كاملة.',
          ],
          tip: 'تُتاح القاعة التي كان يشغلها الاجتماع المحذوف على الفور لحجوزات أخرى.',
        },
        {
          id: 'action-required',
          title: 'الإجراء المطلوب',
          text: 'تنتظرك هنا الطلبات التي تحتاج إلى قرارك، مثل اجتماع عميل يطلب موعدًا حجزته، أو ضيف يطلب نقل اجتماع. وإذا احتاج اجتماعك مع عميل إلى موعد مشغول، تعرض خطوة المراجعة زر إرسال طلب أولوية.',
          steps: [
            'افتح الإجراء المطلوب واختر يحتاج إلى قرارك.',
            'لاجتماع عميل يطلب موعدك، اضغط رفض الطلب أو إعادة جدولة اجتماعي أو إلغاء اجتماعي.',
            'يقترح عليك إعادة جدولة اجتماعي خيارَي الوقت نفسه، قاعة أخرى والقاعة نفسها، وقت آخر، لتحتفظ باجتماعك.',
            'لضيف طلب نقل اجتماع، اضغط موافقة على أحد الأوقات التي اقترحها، أو اقتراح وقت آخر، أو الإبقاء على الموعد الحالي.',
            'افتح الطلبات التي قمت بإرسالها لمتابعة طلبات عملائك، واضغط سحب الطلب إذا لم تعد بحاجة إلى الموعد.',
          ],
          tip: 'يُرفض طلب الأولوية تلقائيًا إذا لم يُرَدّ عليه خلال 20 دقيقة، ويحتفظ الاجتماع المحجوز بموعده.',
        },
        {
          id: 'rooms',
          title: 'العثور على قاعة متاحة',
          text: 'تعرض قاعات الاجتماعات كل قاعة مع عدد مقاعدها وتجهيزاتها، وما إذا كانت قيد الاستخدام الآن، ومتى تتاح بعد ذلك.',
          steps: [
            'افتح قاعات الاجتماعات واختر الكل أو مجاني أو مشغولة.',
            'ابحث بالاسم، أو حدّد سعة القاعة لتجد قاعة تتسع لمجموعتك.',
            'اضغط حجز قاعة على قاعة متاحة، فتُفتح نافذة الجدولة وقد اختيرت القاعة.',
            'على قاعة قيد الاستخدام، اضغط أبلغني عند توفرها ليصلك إشعار إذا أصبحت متاحة.',
          ],
          tip: 'خيار أبلغني عند توفرها تنبيه فقط ولا يحجز القاعة لك، فهي لمن يحجزها أولًا.',
        },
        {
          id: 'messages',
          title: 'الرسائل',
          text: 'راسل زملاءك فرديًا أو في مجموعات داخل مساحة عمل شركتك. تعتمد الرسائل على باقتك، وتحدد إعدادات شركتك من يمكنه إنشاء المجموعات ومشاركة الملفات.',
          steps: [
            'افتح الرسائل واضغط رسالة جديدة.',
            'اختر زميلًا، أو فريقًا من الفرق مثل الاستقبال أو الموارد البشرية، أو اضغط إنشاء مجموعة.',
            'اكتب رسالتك واضغط إرسال، وتظهر شوهدت بعد قراءتها.',
            'اضغط + لإضافة صورة أو ملف أو رسالة صوتية، أو استطلاع في المجموعة. وبعد كتابة رسالة، اختر جدولة رسالة لإرسالها لاحقًا.',
            'مرّر المؤشر على رسالة واضغط رد، أو إجراءات أخرى لتعديلها أو إعادة توجيهها أو تثبيتها، أو لعرض معلومات الرسالة.',
          ],
          tip: 'في المجموعة، اكتب @ ثم اسم الزميل للإشارة إليه، فيصله إشعار.',
        },
        {
          id: 'meeting-chats',
          title: 'محادثات الاجتماعات',
          text: 'يحصل كل اجتماع مؤكد يضم زميلًا آخر على الأقل على محادثة خاصة بجميع الحضور، وتُنشر فيها تغييرات الوقت والقاعة ووصول الضيوف إلى الاستقبال.',
          steps: [
            'افتح الرسائل وابحث عن المحادثة في محادثات الاجتماعات، أو اضغط فتح المحادثة في نافذة الاجتماع.',
            'اكتب تعليقًا للحضور، أو شارك ملفًا، أو ابدأ استطلاعًا.',
            'اضغط عرض الحجز لرؤية الاجتماع نفسه.',
          ],
          tip: 'تبقى المحادثة مفتوحة يومًا واحدًا للمتابعة بعد انتهاء الاجتماع، ثم يختار المنظّم احتفاظ أو حذف.',
        },
        {
          id: 'notifications',
          title: 'الإشعارات',
          text: 'تصلك الدعوات والردود والتذكيرات والتغييرات ووصول الزوار في قائمة واحدة، فلا يفوتك شيء.',
          steps: [
            'افتح الإشعارات واختر الكل أو غير مقروء أو قراءة أو يتطلب اتخاذ إجراء.',
            'اضغط إشعارًا لعرض تفاصيله، أو اضغط زره مثل الرد أو تأكيد القاعة.',
            'اضغط تعليم الكل كمقروء، أو اضغط تحديد لتعليم عدة إشعارات أو حذفها معًا.',
          ],
          tip: 'اختر الإشعارات التي تصلك أيضًا عبر البريد الإلكتروني من ملفك الشخصي، في قسم أرسل إليّ بريدًا بشأن.',
        },
        {
          id: 'history',
          title: 'سجل الاجتماعات',
          text: 'يحتفظ سجل الاجتماعات بسجل لكل تغيير على اجتماعاتك: الإنشاء وإعادة الجدولة والتمديد والإنهاء المبكر والحذف.',
          steps: [
            'افتح سجل الاجتماعات واختر الكل أو تم الإنشاء أو تمت إعادة الجدولة أو تمت الإزالة.',
            'استخدم مربع البحث للعثور على اجتماع باسمه.',
            'اضغط سجلًا لترى ما تغيّر، مثل الموعد السابق والموعد الجديد.',
            'اضغط تحديد لحذف السجلات التي لم تعد تحتاجها.',
          ],
          tip: 'حذف السجل يزيله من سجلك فقط، ولا يغيّر الاجتماع نفسه.',
        },
        {
          id: 'google-calendar',
          title: 'تقويم Google',
          text: 'اربط تقويم Google ليُضاف إليه كل اجتماع تجدوله، مع رابط Meet ودعوات لضيوفك. وتتزامن إعادة الجدولة والإلغاءات أيضًا.',
          steps: [
            'اضغط اسمك أسفل الشريط الجانبي لفتح ملفك الشخصي.',
            'في بطاقة تقويم Google، اضغط ربط وسجّل الدخول بحساب Google.',
            'اضغط زر التحديث مزامنة الاجتماعات الحالية لإضافة الاجتماعات المحجوزة قبل الربط.',
          ],
          tip: 'تعتمد المزامنة على باقتك. وبعد الربط، تُحتسب أوقاتك المشغولة في تقويم Google عندما يتحقق زملاؤك من توفّرك.',
        },
        {
          id: 'profile-language',
          title: 'الملف الشخصي والتنبيهات واللغة',
          text: 'حدّث رقم جوالك، واختر الرسائل التي تصلك بالبريد، واستخدم MeetNPlan بالعربية أو الإنجليزية مع التاريخ الميلادي أو الهجري.',
          steps: [
            'اضغط اسمك أسفل الشريط الجانبي لفتح ملفك الشخصي.',
            'أضف رقم الجوال ليتمكن الاستقبال من الاتصال بك عند وصول زائر.',
            'في أرسل إليّ بريدًا بشأن، أوقف الرسائل التي لا تحتاجها.',
            'في اللغة والتواريخ، اختر English أو العربية، والميلادي أو الهجري.',
            'اضغط حفظ الإعدادات.',
          ],
          tip: 'للتبديل إلى الإنجليزية بضغطة واحدة، استخدم زر EN بجانب اسمك في الشريط الجانبي. ويُحفظ اختيارك في حسابك.',
        },
      ],
    },
    {
      id: 'reception-panel',
      title: 'لوحة الاستقبال',
      intro:
        'لوحة الاستقبال مخصّصة لمكتب الاستقبال. تسجّل وصول الزوار ومغادرتهم وتُبلغ المضيفين عند وصول ضيوفهم.',
      who: 'موظفو الاستقبال',
      features: [
        {
          id: 'front-desk',
          title: 'اطّلع على مكتب الاستقبال بنظرة واحدة',
          text: 'مكتب الاستقبال هو أول شاشة في يومك. يعرض تاريخ اليوم والوقت المتبقي من الدوام وأرقام اليوم، فتعرف مدى انشغال المبنى قبل وصول أول ضيف.',
          steps: [
            'افتح «مكتب الاستقبال» في أعلى الشريط الجانبي.',
            'اقرأ الأرقام الأربعة الكبيرة: «القاعات المتاحة» و«اجتماعات اليوم» و«في المبنى» و«في المكتب».',
            'راجع «المزيد اليوم» لترى من هم «في اجتماع» ومن «لم يصلوا بعد» ومن هم «متأخرون».',
            'اضغط رقمًا مثل «في المبنى» أو «في المكتب» لفتح القائمة التي يعدّها.',
          ],
          tip: 'يدل مؤشر «مباشر» في بطاقة الساعة على أن الشاشة محدّثة، أما «جارٍ إعادة الاتصال» فيعني أنها تستعيد آخر البيانات.',
        },
        {
          id: 'needs-attention',
          title: 'تابِع ما يحتاج إلى متابعة',
          text: 'تعرض بطاقة «يحتاج إلى متابعة» كل من قد يُترك منتظرًا، الأهم فالأهم: ضيف متأخر، أو اجتماع لم يصل ضيوفه بعد، أو زائر مضيفه خارج المكتب، أو قاعة ستُخلى قريبًا، أو زائر ما زال في المبنى بعد انتهاء الدوام. ولكل بند إجراء واحد.',
          steps: [
            'في «مكتب الاستقبال»، راجع بطاقة «يحتاج إلى متابعة». وتعني «لا شيء معلّق» أن لا أحد يحتاج إلى تنبيه.',
            'اضغط إجراء البند، مثل «تسجيل وصول الضيف» أو «فتح الاجتماع» أو «الاتصال بالمضيف» أو «تذكير المضيف» أو «مغادرة دون توقيع».',
            'افتح البند لترى تفاصيله، واضغط «اتصال» للاتصال بالشخص المعني.',
            'اضغط «إسكات» لإخفاء البند 15 دقيقة، ويعود إن ظل بحاجة إليك.',
          ],
          tip: 'في بقية التبويبات تظهر التنبيهات نفسها في بطاقات عائمة، فلا يفوتك شيء أثناء عملك.',
        },
        {
          id: 'expected-guest',
          title: 'سجّل وصول ضيف متوقَّع',
          text: 'يظهر الضيوف المدعوون إلى اجتماعات اليوم والغد في «القادمون» ضمن «الزوار»، وبياناتهم مأخوذة من الدعوة. ويتوفر «القادمون» عندما تشمل باقتك دعوة الضيوف.',
          steps: [
            'افتح «الزوار» ثم «القادمون»، واختر «اليوم» أو «غدًا». واختر «لم يصلوا بعد» أو «متأخرون» لتضييق القائمة.',
            'اضغط «تسجيل وصول» في صف الضيف. راجع «بيانات الضيف»، واضغط «تعديل» لتصحيح ما تغيّر.',
            'اضغط «التالي». وعند «هل يرافقه أحد؟» اختر «نعم، يرافقه أحد» وأضف كل شخص، أو «لا، هو وحده».',
            'راجع «تأكيد الزيارة» واضغط «التالي»، ثم سلّم الشاشة إلى الضيف ليوقّع داخل المربع.',
            'اضغط «تسجيل وصول». يُبلَّغ المضيف، وتعرض النافذة التوقيع المحفوظ حتى تضغط «تم».',
          ],
          tip: 'إذا أوقف المسؤول التوقيع عند الوصول، فاضغط «تسجيل وصول» في «تأكيد الزيارة» دون أن يوقّع الضيف.',
        },
        {
          id: 'walk-in',
          title: 'سجّل زائرًا بلا موعد',
          text: 'الزائر بلا موعد هو من يصل دون دعوة، مثل مندوب توصيل أو متقدّم لمقابلة. ويوجد زر «تسجيل زائر بلا موعد» في الشريط الجانبي، فهو على بُعد ضغطة واحدة من أي تبويب.',
          steps: [
            'اضغط «تسجيل زائر بلا موعد» في الشريط الجانبي أو في صفحة «الزوار».',
            'أدخل «الاسم الكامل» و«الشركة»، ثم رقم الجوال في خانة «الجوال». واضغط «متابعة» بعد كل شاشة.',
            'اختر المضيف الذي سيقابله، ثم اختر غرض الزيارة، مثل «اجتماع» أو «توصيل».',
            'استخدم «مرافقون إضافيون» لإضافة من معه. وإذا كانت مساحة العمل تطلب توقيعًا، فسيوقّع الزائر بعد ذلك.',
            'راجع شاشة «المراجعة» واضغط «تسجيل وصول».',
          ],
          tip: 'يُبلَّغ المضيف فور تسجيل وصول الزائر. وإن تعذّر إبلاغ أحد تذكر ذلك الشاشة الأخيرة، فاتصل بالمضيف.',
        },
        {
          id: 'vip',
          title: 'استقبل أحد كبار الزوار',
          text: 'عندما يحدّد المضيف ضيفًا من كبار الزوار عند حجز اجتماع عميل في غرفة، يظهر الضيف في «كبار الزوار» يوم الاجتماع. ولا يوقّع كبار الزوار شيئًا: ضغطة واحدة تسجّل وصولهم دون نموذج.',
          steps: [
            'افتح «كبار الزوار»، أو ابحث عن الضيف أو مضيفه.',
            'اضغط «تسجيل وصول» عند وصول الضيف، فيُبلَّغ المضيف.',
            'عند مغادرة الضيف، اضغط «تسجيل المغادرة».',
            'إذا عاد الضيف واجتماعه ما زال قائمًا، فاضغط «تسجيل الوصول مجددًا».',
          ],
          tip: 'يظهر كبار الزوار أيضًا في «الزوار» بوسم «مميّز»، وتسجيل وصولهم من هناك لا يتطلب نموذجًا كذلك.',
        },
        {
          id: 'host-alerts',
          title: 'تابِع تنبيهات المضيفين وردودهم',
          text: 'في كل مرة تسجّل فيها وصول زائر، يُبلغ MeetNPlan المضيف في محادثة الاستقبال الخاصة به، ويستطيع المضيف الرد بضغطة واحدة. وتعرض «تنبيهات المضيفين» كل تنبيه، وهل شاهده المضيف وبماذا ردّ، عندما تكون الرسائل مفعّلة في مساحة العمل.',
          steps: [
            'افتح «تنبيهات المضيفين». يعرض أعلى الصفحة أرقام اليوم: «مُرسَلة» و«مُجابة» و«بانتظار المضيف».',
            'اختر «اليوم» أو «أمس» أو «هذا الأسبوع»، أو ابحث عن زائر أو مضيف.',
            'افتح تفاصيل الصف لترى وقت الإرسال ووقت المشاهدة و«الرد»، مثل «أنا في الطريق» أو «انتظر 5 دقائق».',
            'إذا كان الزائر ما زال ينتظر، فاضغط «إرسال مرة أخرى». واضغط «فتح المحادثة» لتكتب إلى المضيف بنفسك.',
          ],
          tip: 'لمراسلة مضيف مباشرة، اضغط «تنبيه مضيف» واختره، فتُفتح محادثته في «الرسائل».',
        },
        {
          id: 'whos-in',
          title: 'اعثر على زميل في «من في المكتب»',
          text: 'تعرض «من في المكتب» أين كل زميل اليوم، في المكتب أو في اجتماع أو في زيارة خارجية، مع الرقم للتواصل معه. استخدمها عندما يسأل زائر عن أحد.',
          steps: [
            'افتح «من في المكتب»، أو اختر عرضًا تحتها في الشريط الجانبي، مثل «في المكتب» أو «متفرغون».',
            'ابحث بالاسم أو البريد الإلكتروني، ثم افتح صف الشخص.',
            'اقرأ «الآن» و«التالي» لمعرفة اجتماعه الحالي والتالي، واضغط «اتصال» أو «مراسلة» للتواصل معه.',
            'اضغط «تسجيل حضور» عند وصوله و«تسجيل غياب» عند مغادرته.',
          ],
          tip: '«متفرغ» تعني أنه لا اجتماع محجوز له في MeetNPlan، فقد يكون مشغولًا بأمر آخر.',
        },
        {
          id: 'visitor-record',
          title: 'راجع زيارة وصحّحها',
          text: 'لكل زيارة سجل يضم الشركة والمضيف والاجتماع والأشخاص المرافقين والتوقيعين وتسلسلًا لما جرى. افتحه من أي صف في «الزوار».',
          steps: [
            'افتح «الزوار» واضغط صف الزائر لفتح سجله.',
            'اضغط «تعديل الزيارة» لتصحيح بيانات الزائر أو المضيف، ثم اضغط «حفظ التغييرات».',
            'في «الأشخاص»، اضغط «إضافة شخص» لإضافة من انضم إليه لاحقًا.',
            'أثناء انتظار الزائر، اضغط «الاتصال بالمضيف»، أو «تذكير المضيف» لإبلاغه بأن زائره ما زال ينتظر.',
          ],
          tip: 'يمكنك تذكير المضيف مرة كل 5 دقائق للزائر نفسه.',
        },
        {
          id: 'reception-messages',
          title: 'أجب الزملاء في «الرسائل»',
          text: 'يستطيع الزملاء مراسلة الاستقبال، ويرى الرسالة من في مكتب الاستقبال، عندما تكون الرسائل مفعّلة في مساحة العمل. وتُرتَّب المحادثات حسب من يجيب عنها: «بانتظار الرد» و«محادثاتي» و«لدى زملائي» و«سابقًا».',
          steps: [
            'افتح «الرسائل» واختر محادثة من «بانتظار الرد».',
            'اضغط «استلام المحادثة» ليعرف بقية فريق الاستقبال أنك تتولاها، ثم اكتب ردك.',
            'اضغط «تحويل إلى…» لتسليم المحادثة لزميل، أو «إنهاء» لإعادتها إلى الفريق.',
            'اضغط «رسالة جديدة» لتراسل أي شخص في الشركة باسم الاستقبال.',
          ],
          tip: 'إذا غاب الزميل الذي يتولى المحادثة 7 دقائق، يمكنك الضغط على «تولّي المحادثة» والرد بنفسك.',
        },
        {
          id: 'sign-out-visitor',
          title: 'سجّل مغادرة زائر',
          text: 'سجّل مغادرة الزوار عند خروجهم، ليُظهر سجل الزوار من ما زال في المبنى. ويُسجَّل خروج كل من جاء معهم في الوقت نفسه.',
          steps: [
            'افتح «الزوار» ثم «في المبنى».',
            'اضغط «تسجيل مغادرة» في صف الزائر.',
            'تحقّق ممن يغادر، واطلب من الزائر التوقيع داخل المربع، ثم اضغط «تسجيل مغادرة».',
            'إذا غادر دون توقيع، فاضغط «غادر الزائر بالفعل» بدلًا من ذلك.',
          ],
          tip: 'إذا تعذّر على الزائر رسم توقيعه، فاضغط «الكتابة بدلًا من ذلك» واكتب اسمه.',
        },
      ],
    },
    {
      id: 'hr-panel',
      title: 'لوحة الموارد البشرية',
      intro:
        'لوحة الموارد البشرية هي المكان الذي تُعتمد فيه الطلبات ويُعتنى فيه بالأشخاص.',
      who: 'فريق الموارد البشرية',
      features: [
        {
          id: 'hr-needs-action',
          title: 'ابدأ من بانتظار إجرائك',
          text: 'تجمع لوحة الموارد البشرية ما ينتظر الموارد البشرية: من لا رقم جوال لهم، وطلبات الانضمام، والدعوات التي لم تُقبل، وطلبات الحجز، وتعارضات الحجز.',
          steps: [
            'افتح لوحة التحكم وانظر إلى بانتظار إجرائك.',
            'اضغط مراجعة في طلبات الانضمام أو طلبات الحجز لتقرّر فيها.',
            'اضغط عرض الدعوات لترى دعوات البريد التي لم تُقبل بعد.',
            'اضغط مراجعة التعارضات لترى طلبات العملاء التي تتداخل مع اجتماع.',
          ],
          tip: 'تظهر طلبات الحجز ما دام حجز القاعات مباشرة معطّلًا أو توجد طلبات منتظرة، ولا تظهر تعارضات الحجز إلا في الخطط التي تشمل اجتماعات العملاء.',
        },
        {
          id: 'phone-reminders',
          title: 'ذكّر الأشخاص بإضافة رقم الهاتف',
          text: 'لا يستطيع الاستقبال الاتصال بمن لا رقم لهم عند وصول ضيوفهم. تعرض بطاقة رقم الهاتف غير مضاف هؤلاء الأشخاص لتذكّرهم بالبريد الإلكتروني.',
          steps: [
            'افتح لوحة التحكم وانتقل إلى رقم الهاتف غير مضاف.',
            'اضغط تذكير بجانب الشخص.',
            'أو اضغط تذكير الجميع لتذكير كل من في القائمة دفعة واحدة.',
          ],
          tip: 'يخرج الشخص من القائمة بمجرد إضافة رقمه.',
        },
        {
          id: 'hr-shared-screens',
          title: 'تعامل مع الأشخاص والقاعات والحجوزات',
          text: 'تستخدم الموارد البشرية شاشات المستخدمون ودعوة أعضاء والقاعات والحجوزات وحجوزات العملاء نفسها التي يستخدمها المسؤولون. لا تغيّر الموارد البشرية الأدوار، وليس لها الفوترة ولا الدعم.',
          steps: [
            'افتح المستخدمون ‹ الكل لإزالة عضو أو إعادة فتح طلب مرفوض. ولا يستطيع إزالة مسؤول إلا مسؤول آخر.',
            'افتح دعوة أعضاء ‹ نظرة عامة لإرسال دعوات بالبريد ونسخ الرابط القابل للمشاركة، الذي يفعّله المسؤول أو يعطّله.',
            'افتح دعوة أعضاء ‹ الطلبات المعلقة للموافقة على طلبات الانضمام أو رفضها.',
            'افتح القاعات ‹ إضافة أو تحرير قاعة لإضافة القاعات وتعديلها وحذفها كما يفعل المسؤولون.',
            'افتح الحجوزات ‹ الكل للموافقة على الحجوزات المنتظرة أو رفضها. ويبقى حذف الحجوزات وتجاوز تعارضات العملاء للمسؤولين.',
          ],
          tip: 'ينضم كل من تدعوه بدور مستخدم، ويمكن للمسؤول تغيير الأدوار لاحقًا.',
        },
        {
          id: 'activity-log',
          title: 'تابع سجل النشاط',
          text: 'يعرض النشاط عمليات الانضمام والدعوات وتغييرات الأدوار وتحديثات القاعات وتذكيرات الهاتف والموافقات على الحجوزات وتعارضاتها في الشركة كلها، الأحدث أولًا ومجمّعة حسب اليوم.',
          steps: [
            'افتح النشاط ‹ كل النشاط.',
            'اختر الأشخاص أو الدعوات أو القاعات أو الحجوزات لترى قسمًا واحدًا في كل مرة.',
            'ابحث بالشخص أو الإجراء أو التفاصيل.',
            'اضغط صفًا لترى من قام به ومتى، ومعرّف الحدث.',
          ],
        },
        {
          id: 'hr-settings',
          title: 'أدِر الإعدادات بصفتك الموارد البشرية',
          text: 'تضم صفحة إعدادات الموارد البشرية صلاحيات الأعضاء وقواعد الحجز وساعات العمل وأيام الإجازة والقاعات غير المستخدمة وإعدادات الزوار نفسها التي لدى المسؤول. ويبقى الاسم والشعار والنطاقات بيد المسؤول.',
          steps: [
            'افتح الإعدادات.',
            'غيّر ما تحتاجه في صلاحيات الأعضاء أو قواعد الحجز أو ساعات العمل أو أيام الإجازة أو القاعات غير المستخدمة أو الزوار أو وصول الزوار.',
            'اضغط حفظ الإعدادات، أو تجاهل للتراجع عن تغييراتك.',
          ],
          tip: 'يظهر رمز الشركة أعلى الصفحة، جاهزًا لمشاركته مع المنضمين الجدد.',
        },
        {
          id: 'hr-emails',
          title: 'اختر رسائل الموارد البشرية',
          text: 'يمكن أن يرسل MeetNPlan إلى فريق الموارد البشرية رسائل عن الطلبات الجديدة والإلغاءات وملخصًا أسبوعيًا. الثلاثة معطّلة حتى تفعّلها.',
          steps: [
            'افتح الإعدادات ‹ الإشعارات.',
            'فعّل الطلبات الجديدة أو الإلغاءات أو الملخص الأسبوعي.',
            'اضغط حفظ الإعدادات.',
          ],
          tip: 'يشمل الملخص الأسبوعي الحجوزات والزوار، ويصل كل صباح أحد.',
        },
        {
          id: 'send-announcements',
          title: 'أرسل الإعلانات',
          text: 'يمكن للموارد البشرية والمسؤولين إرسال إعلانات في الرسائل إلى الجميع أو إلى أدوار أو أشخاص محدّدين، ما لم يقصرها المسؤول على المسؤولين فقط. تظهر الرسائل حين تتوفر لمساحة عملك.',
          steps: [
            'افتح الرسائل واضغط إعلان جديد.',
            'في إرسال إلى، اختر الجميع أو الأدوار أو أشخاص محدّدون.',
            'اكتب العنوان والرسالة، وفعّل عاجل أو تثبيت في الأعلى أو تأكيد القراءة عند الحاجة.',
            'اضغط زر الإرسال، الذي يبيّن عدد من سيصلهم الإعلان.',
          ],
          tip: 'تظهر الإعلانات العاجلة بالأحمر وتُرسل بالبريد أيضًا.',
        },
      ],
    },
    {
      id: 'admin-panel',
      title: 'لوحة المسؤول',
      intro: 'تُعدّ لوحة المسؤول شركتك: القاعات والأشخاص والقواعد والفوترة.',
      who: 'مسؤولو الشركة',
      features: [
        {
          id: 'admin-dashboard',
          title: 'اقرأ لوحة التحكم',
          text: 'تعرض لوحة التحكم ما يحتاج إلى انتباهك، ومدى نشاط مساحة العمل، وكم تستخدم من خطتك.',
          steps: [
            'افتح لوحة التحكم.',
            'راجع قائمة التنبيهات في الأعلى، ثم اضغط طلبات مفتوحة أو مراجعة الآن للتعامل مع ما ينتظرك.',
            'اطّلع على حجوزات هذا الشهر والقاعات المتاحة الآن والاستخدام خلال هذه الفترة لترى كيف تُستخدم مساحة العمل.',
            'اضغط إدارة الخطة للانتقال مباشرة إلى الفوترة.',
          ],
          tip: 'تظهر تنبيهات الخطة أيضًا في قائمة التنبيهات، مثل تأخر الدفع أو تجاوز أحد الحدود.',
        },
        {
          id: 'set-up-rooms',
          title: 'جهّز القاعات',
          text: 'أضف كل قاعة اجتماعات بعدد مقاعدها وتجهيزاتها وصورتها ليتمكن فريقك من حجزها. يعتمد عدد القاعات التي يمكنك إضافتها على خطتك.',
          steps: [
            'افتح القاعات ‹ إضافة أو تحرير قاعة، أو اضغط إضافة قاعة.',
            'اختر قاعة جديدة، أو اختر قاعة من أو تعديل قاعة موجودة، ثم اضغط التالي.',
            'أدخل اسم القاعة والسعة، ثم اضغط التالي.',
            'في خطوة التجهيزات، حدّد كل ما في القاعة وأضف صورة القاعة إن وُجدت (JPG أو PNG أو WEBP حتى 8 ميغابايت).',
            'اضغط إنشاء القاعة، أو حفظ التغييرات لقاعة موجودة.',
          ],
          tip: 'تتحدّث المعاينة بجانب المحرر أثناء الكتابة، ولا يرى أحد غيرك القاعة حتى تحفظ.',
        },
        {
          id: 'company-identity',
          title: 'اضبط هوية شركتك',
          text: 'امنح مساحة العمل اسم مؤسستك وشعارها ولغتها وتقويمها، وحدّد نطاقات البريد التي ينضم بها فريقك.',
          steps: [
            'افتح الإعدادات ‹ الهوية.',
            'اضغط رفع الشعار، واضغط تعديل الاسم لتغيير اسم المؤسسة.',
            'في اللغة والتقويم، اختر لغة مساحة العمل والتقويم ميلادي أو هجري.',
            'في النطاقات المعتمدة، اكتب نطاق بريدك مثل company.com واضغط إضافة.',
            'اضغط حفظ الإعدادات.',
          ],
          tip: 'لا يمكن أن يكون مزوّد بريد شخصي نطاقًا للشركة، ولا يمكن إضافة نطاق محجوز لمؤسسة أخرى.',
        },
        {
          id: 'invite-your-team',
          title: 'ادعُ فريقك',
          text: 'أدخل الأشخاص عبر رابط قابل للمشاركة أو دعوة بالبريد الإلكتروني أو رمز شركتك الدائم. ويبقى كل طلب انضمام بحاجة إلى موافقة.',
          steps: [
            'افتح دعوة أعضاء ‹ نظرة عامة.',
            'فعّل رابط دعوة قابل للمشاركة واضغط نسخ لمشاركته.',
            'في الدعوة عبر البريد الإلكتروني، اكتب حتى 10 عناوين تفصل بينها فاصلة أو مسافة، ثم اضغط إرسال.',
            'لاستخدام رمز الشركة بدلًا من ذلك، افتح الإعدادات ‹ الهوية واضغط نسخ بجانب رمز الشركة.',
          ],
          tip: 'اضغط إنشاء رابط جديد لاستبدال الرابط، فيتوقف الرابط القديم عن العمل.',
        },
        {
          id: 'approve-join-requests',
          title: 'وافق على طلبات الانضمام',
          text: 'كل من ينضم عبر الرابط أو البريد الإلكتروني أو رمز الشركة أو نطاق الشركة ينتظر الموافقة. أنت تقرر من يدخل، ويُبلَّغ كل شخص بالنتيجة.',
          steps: [
            'افتح دعوة أعضاء ‹ الطلبات المعلقة.',
            'اضغط عرض التفاصيل لترى متى طلب الشخص الانضمام وكيف.',
            'اضغط الموافقة أو رفض، أو اضغط الموافقة على الكل لقبول الجميع.',
            'لمنح شخص مرفوض فرصة أخرى، افتح المستخدمون ‹ مرفوض، واضغط عرض التفاصيل في صفّه، ثم اضغط إعادة فتح الطلب.',
          ],
          tip: 'تحجز الطلبات المعلّقة مقعدًا إلى أن تقرّر، لذا تتوقف الموافقة حين لا يبقى في خطتك مقاعد.',
        },
        {
          id: 'roles-and-access',
          title: 'غيّر الأدوار وأزِل الأشخاص',
          text: 'امنح كل شخص الدور الذي يحتاجه: المستخدم يحجز القاعات والاجتماعات، والموارد البشرية تطّلع على بيانات الأعضاء، والاستقبال يستقبل الضيوف عند وصولهم، والمسؤول له صلاحية كاملة على مساحة العمل. بعض الأدوار محدودة بحسب خطتك.',
          steps: [
            'افتح المستخدمون ‹ الكل وابحث عن الشخص.',
            'اختر مستخدم أو الموارد البشرية أو الاستقبال أو مسؤول من قائمة الدور في صفّه.',
            'لإزالة شخص، اضغط أيقونة سلة المهملات، واكتب اسمه، ثم اضغط حذف. يُحذف حساب دخوله واجتماعاته وحجوزاته.',
          ],
          tip: 'لا يمكنك تغيير دورك بنفسك ولا دور مؤسس الشركة، ويبقى للشركة دائمًا مسؤول واحد على الأقل.',
        },
        {
          id: 'member-permissions',
          title: 'حدّد ما يمكن للأعضاء فعله',
          text: 'تحدّد صلاحيات الأعضاء ما يمكن للأعضاء فعله دون موافقة الموارد البشرية، من حجز القاعات مباشرة إلى دعوة الزملاء والضيوف.',
          steps: [
            'افتح الإعدادات ‹ صلاحيات الأعضاء.',
            'فعّل أو عطّل حجز القاعات مباشرة، ودعوة أعضاء جدد، ودعوة ضيوف من خارج الشركة، والسماح للاستقبال باستخدام تطبيق الحجز.',
            'اضغط حفظ الإعدادات.',
          ],
          tip: 'عند تعطيل حجز القاعات مباشرة، تنتظر حجوزات الأعضاء للقاعات الموافقة في الحجوزات.',
        },
        {
          id: 'booking-rules',
          title: 'اضبط قواعد الحجز',
          text: 'تضع قواعد الحجز حدودًا لكل حجز في مساحة العمل، ويُخلي قسم القاعات غير المستخدمة القاعات التي لا يحضر إليها أحد.',
          steps: [
            'افتح الإعدادات ‹ قواعد الحجز.',
            'اضبط أقصى مدة للحجز والحجز مسبقًا حتى والتداخل المسموح.',
            'في القاعات غير المستخدمة، فعّل إخلاء القاعات التي لا يؤكّدها أحد واضبط مدة الانتظار قبل الإخلاء.',
            'فعّل إلغاء الاجتماع أيضًا إن أردت إزالة الاجتماع من التقاويم كذلك.',
            'اضغط حفظ الإعدادات.',
          ],
          tip: 'عند تفعيل إخلاء القاعات التي لا يؤكّدها أحد، يُطلب من كل مدعو التأكيد، وإن لم يؤكّد أحد تُتاح القاعة للآخرين.',
        },
        {
          id: 'working-hours-days-off',
          title: 'اضبط ساعات العمل وأيام الإجازة',
          text: 'تحدّد ساعات العمل متى يمكن حجز القاعات، ولا تظهر أيام الإجازة في التقويم ولا في نموذج الحجز.',
          steps: [
            'افتح الإعدادات ‹ ساعات العمل.',
            'اختر ساعة البدء وساعة الانتهاء والمنطقة الزمنية.',
            'في أيام الإجازة، اضغط يومًا لتبديله بين مفتوح وإجازة.',
            'اضغط حفظ الإعدادات.',
          ],
          tip: 'تتكرر أيام الإجازة كل أسبوع، فاختر أيام الأسبوع التي يُغلق فيها مكتبك.',
        },
        {
          id: 'welcome-visitors',
          title: 'استعد لاستقبال الزوار',
          text: 'أخبر ضيوفك كيف يصلون إليك. يظهر عنوانك وخريطتك وهاتف التواصل وتعليماتك في رسالتي التذكير والشكر.',
          steps: [
            'افتح الإعدادات ‹ وصول الزوار.',
            'املأ العنوان ورابط الخريطة (أو اضغط استخدم موقعي) وهاتف التواصل وتعليمات الوصول، وأضف رابط التقييم إن وُجد.',
            'في دليل الزائر (PDF)، اضغط أضف ملف PDF لإرفاق خريطة المواقف أو مخطط الطابق حتى 10 ميغابايت.',
            'في الزوار، اضبط إرسال تفاصيل الوصول والاحتفاظ بسجلات الزوار وطلب توقيع عند الوصول.',
            'اضغط حفظ الإعدادات.',
          ],
          tip: 'عند تفعيل طلب توقيع عند الوصول، يوقّع الضيوف على جهاز الاستقبال اللوحي عند تسجيل دخولهم.',
        },
        {
          id: 'manage-bookings',
          title: 'تابع الحجوزات',
          text: 'تعرض الحجوزات كل اجتماع محجوز في مؤسستك: حجوزات القاعات وزيارات العملاء والاجتماعات عن بُعد.',
          steps: [
            'افتح الحجوزات ‹ الكل، أو اختر عميل أو داخلي أو شخصي.',
            'ابحث، ثم اضغط عرض التفاصيل في صف لترى القاعة والوقت والمنظّم والحضور.',
            'للحجز المعلّق، اضغط موافقة، أو اكتب سببًا إن أردت واضغط رفض. يُبلَّغ المنظّم في الحالتين.',
            'لحذف حجوزات، اضغط تحديد، وحدّدها، ثم اضغط حذف المحدد.',
          ],
          tip: 'يحجز الحجز المنتظر للموافقة القاعة حتى تقرّر، وينتهي عند موعد بدئه.',
        },
        {
          id: 'client-bookings',
          title: 'تابع حجوزات العملاء',
          text: 'تجمع حجوزات العملاء الاجتماعات مع العملاء من خارج المؤسسة وحالة الموافقة عليها. تظهر في الخطط التي تشمل اجتماعات العملاء.',
          steps: [
            'افتح حجوزات العملاء ‹ الكل، أو افتح حسب الحالة واختر معلّق أو تمت الموافقة أو تمت إعادة الجدولة أو مرفوضة أو ملغاة.',
            'اختر قاعة من قائمة جميع القاعات لتضييق القائمة.',
            'إذا تعارض طلب عميل مع اجتماع محجوز، يُمنح منظّم الاجتماع وقتًا محددًا للرد. وعندما يظهر التجاوز جاهز، اضغط تجاوز لمنح الموعد للعميل.',
            'افتح حجوزات العملاء ‹ سجل الموافقات لترى كل موافقة ورفض وتجاوز.',
          ],
          tip: 'حذف اجتماع عميل يزيله لكل المدعوين، ويُبلَّغ الضيوف الذين لديهم بريد إلكتروني بالبريد.',
        },
        {
          id: 'chat-rules',
          title: 'اضبط قواعد الرسائل',
          text: 'حدّد من يمكنه إنشاء المجموعات وإرسال الإعلانات، وما يمكن مشاركته في المحادثات، ومدة الاحتفاظ بالرسائل. تظهر هذه البطاقات في الإعدادات حين تتوفر الرسائل لمساحة عملك.',
          steps: [
            'افتح الإعدادات ‹ الصلاحيات.',
            'في إنشاء المجموعات وإرسال الإعلانات، اختر من يُسمح له بكل منهما.',
            'في المحتوى، فعّل أو عطّل المرفقات والرسائل الصوتية، واضبط أكبر حجم للملف والتعديل والحذف.',
            'في الاحتفاظ، اضبط الاحتفاظ بالرسائل ومحادثات الاجتماعات.',
            'فعّل ساعات الهدوء في الإعلانات إن أردت، ثم اضغط حفظ الإعدادات.',
          ],
          tip: 'عند تفعيل ساعات الهدوء، لا تُرسل رسائل بريد عاجلة خارج ساعات العمل ولا في أيام الإجازة.',
        },
        {
          id: 'manage-billing',
          title: 'أدِر خطتك وفواتيرك',
          text: 'تعرض الفوترة خطتك، وما تستخدمه مقابل حدودها، وكل دفعة سدّدتها. تُطبَّق حدود الخطة الجديدة بعد إتمام الدفع.',
          steps: [
            'افتح الفوترة ‹ الخطة الحالية والاستخدام لترى خطتك وموعد تجديدها واستخدامك.',
            'افتح الفوترة ‹ الخطط والإضافات، ثم اضغط اختر الخطة على الخطة التي تريدها، أو استخدم عدّادات الإضافات لزيادة السعة.',
            'راجع ملخص الدفع واضغط المتابعة إلى الدفع.',
            'افتح الفوترة ‹ الفواتير واضغط تنزيل PDF على فاتورة، أو تنزيل الكل.',
            'للإيقاف، اضغط إلغاء الخطة في الخطة الحالية والاستخدام، واختر في نهاية فترة الفوترة أو فورًا، ثم اضغط إلغاء الاشتراك.',
          ],
          tip: 'إذا انتهت خطتك، تصبح اللوحة للقراءة فقط حتى تجدّدها. بياناتك في أمان، وتبقى الفوترة والإعدادات متاحة.',
        },
        {
          id: 'get-support',
          title: 'اطلب المساعدة من الدعم',
          text: 'أرسل طلبًا إلى فريق MeetNPlan من اللوحة وتابعه حتى يُغلق. الدعم متاح في كل الخطط، وتضيف خطة Enterprise مدير حساب مخصّصًا.',
          steps: [
            'افتح الدعم ‹ اطلب المساعدة.',
            'في عمّ يدور الأمر؟ اختر ما يناسب، ثم املأ الموضوع والتفاصيل.',
            'اضغط إرسال الطلب.',
            'افتح الدعم ‹ طلباتك لترى إن كان كل طلب مفتوح أو تمت الإجابة أو مغلق.',
          ],
          tip: 'تصلك الردود بالبريد الإلكتروني. ردّ على تلك الرسالة لإضافة أي شيء، دون حاجة لإرسال طلب آخر.',
        },
        {
          id: 'danger-zone',
          title: 'امسح البيانات القديمة أو احذف المؤسسة',
          text: 'تتيح منطقة الخطر أسفل الإعدادات مسح الحجوزات القديمة وسجل الاجتماعات، أو حذف المؤسسة كلها. يبقى الأعضاء والقاعات والإعدادات وسجلات الزوار عند مسح البيانات.',
          steps: [
            'افتح الإعدادات ‹ منطقة الخطر.',
            'لمسح البيانات القديمة، اختر تاريخًا في المسح حتى، واضغط مسح البيانات، واكتب اسم مؤسستك، ثم اضغط نعم، احذف.',
            'لحذف المؤسسة، أزِل الأعضاء الآخرين وألغِ اشتراكك أولًا.',
            'اضغط حذف المؤسسة، واكتب اسم المؤسسة، ثم اضغط حذف المؤسسة مرة أخرى.',
          ],
          tip: 'يمكن استعادة المؤسسة المحذوفة بتسجيل الدخول والضغط على استعادة خلال 30 يومًا.',
        },
      ],
    },
  ],
}
